export const SocketUrl = {
  reconnect: "reconnect",
  connect: "connect",
  messagePolling: "messagePolling",
  messagePollingReceivedAck: "messagePollingReceivedAck",
  userJoinToApp: "userJoinToApp",
  lastUserActivity: "lastUserActivity",
  userTyping: "userTyping",
  updateUserMessageReadStatus: "updateUserMessageReadStatus",
  userJoinToChatRoom: "userJoinToChatRoom",
  leaveChatRoom: "leaveChatRoom",
  typing: "typing",
  disconnect: "forceDisconnect",
  userMessage: "userMessage",
  updateUserMessage: "updateUserMessage",
  userSendMessage: "userSendMessage",
  userInformationHandOff: "userInformationHandOff",
  updateUserToken: "updateUserToken",
  roomNameChangeNotification: "roomNameChangeNotification",
  updateChatMessageDeleteStatus: "updateChatMessageDeleteStatus",
} as const;
